import React from 'react';
import FullDoctors from './FullDoctors/FullDoctors';

const Doctors = () => {
    return (
        <div className='container'>
            <h1>Our Team</h1>
            <hr />
            <FullDoctors></FullDoctors>
        </div>
    );
};

export default Doctors;